import { PaymentMethod } from '@stripe/stripe-js'
import CardIcon, { Card as CardType } from './card-icon'
import ProductCard from './product-card'

interface CardProps {
  card: PaymentMethod.Card
}

export default function Card({ card }: CardProps): JSX.Element {
  return (
    <div>
      <h3 className="tw-custom-reset-heading tw-font-medium tw-mb-3">
        Payment Method
      </h3>
      <ProductCard>
        <div className="tw-w-12 tw-flex tw-items-center tw-justify-center">
          <CardIcon cardType={card.brand as CardType} />
        </div>
        <div className="tw-flex tw-flex-col tw-ml-5">
          <span className="tw-font-medium">xxxx xxxx xxxx {card.last4}</span>
          <span className="tw-text-sm tw-text-system-grey-500">
            Expires {card.exp_month}/{card.exp_year}
          </span>
        </div>
      </ProductCard>
    </div>
  )
}
